// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { default as AtlasButton } from '@atlaskit/button';
import { token } from '@atlaskit/tokens';

// We have to override styles right here since @atlaskit/button doesn't have a prop to customize them
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AddConditionButton = styled(AtlasButton)`
	padding: 0 !important;
	max-width: fit-content !important;
	margin-top: ${token('space.100', '8px')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ConditionsWrapper = styled.div({
	display: 'grid',
	gap: token('space.100', '8px'),
	marginTop: token('space.100', '8px'),
});
